<p-toast></p-toast>

<div class="page-header">
  <div>
    <h1 class="title">{{ pageTitleKey() | translate }}</h1>
    <p class="sub">{{ pageSubtitleKey() | translate }}</p>
  </div>

  <div class="filters">
    <input
      pInputText
      [(ngModel)]="filters.search"
      [placeholder]="'USERS.SEARCH_PLACEHOLDER' | translate"
      (keyup.enter)="applyFilters()"
    />
    <p-dropdown
      [options]="[
        { label: 'الكل', value: '' },
        { label: 'نشط', value: 'active' },
        { label: 'معطل', value: 'inactive' },
        { label: 'مقفل', value: 'locked' },
        { label: 'محذوف', value: 'deleted' }
      ]"
      [(ngModel)]="filters.status"
      placeholder="الحالة"
      styleClass="w-40"
      appendTo="body"
    ></p-dropdown>
    <p-toggleButton
      [(ngModel)]="filters.includeDeleted"
      onLabel="يشمل المحذوف"
      offLabel="إخفاء المحذوف"
      onIcon="pi pi-eye"
      offIcon="pi pi-eye-slash"
      styleClass="deleted-toggle"
      (onChange)="applyFilters()"
    ></p-toggleButton>
    <button pButton icon="pi pi-search" [label]="'COMMON.SEARCH' | translate" (click)="applyFilters()"></button>
    <button pButton icon="pi pi-times" label="مسح" class="p-button-secondary" (click)="clearFilters()"></button>
    <button
      pButton
      icon="pi pi-plus"
      [label]="'USERS.ADD_USER' | translate"
      (click)="openAdd()"
    ></button>
  </div>
</div>

<div class="table-scroll">
<p-table
  [value]="users()"
  [lazy]="true"
  [loading]="loading()"
  (onLazyLoad)="onPageChange($event)"
  [paginator]="true"
  [rows]="pagination.rows"
  [totalRecords]="totalRecords()"
  [first]="pagination.first"
  [rowsPerPageOptions]="[10, 20, 50, 100]"
  [tableStyle]="{ 'min-width': '72rem' }"
  styleClass="user-table"
  [sortField]="pagination.sortField"
  [sortOrder]="pagination.sortOrder === 'asc' ? 1 : -1"
  (onSort)="onSort($event)"
>
  <ng-template pTemplate="header">
    <tr>
      <th>المستخدم</th>
      <th>معلومات الاتصال</th>
      <th *ngIf="!relaxedEmployeeBranch()">الموظف</th>
      <th *ngIf="!relaxedEmployeeBranch()">الفروع</th>
      <th *ngIf="relaxedEmployeeBranch()">
        {{ isPortalEntityUsersPortal() ? (portalEntitySectionKey | translate) : ('INSURANCE_USERS.COL_COMPANY' | translate) }}
      </th>
      <th>الحالة</th>
      <th>الأدوار</th>
      <th>المجموعات</th>
      <th>آخر دخول</th>
      <th class="text-end">إجراءات</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-u>
    <tr [class.deleted-row]="u.isDeleted">
      <td>
        <div class="user-cell">
          <div class="avatar">{{ (u.username?.[0] || 'U') | uppercase }}</div>
          <div class="meta">
            <div class="name">{{ u.fullName || u.username }}</div>
            <div class="sub">{{ '@' + (u.username || '') }}</div>
          </div>
        </div>
      </td>

      <td>
        <div class="contact-info">
          <div class="email" *ngIf="u.email">{{ u.email }}</div>
          <div class="phone" *ngIf="u.phone">{{ u.phone }}</div>
          <span *ngIf="!u.email && !u.phone">—</span>
        </div>
      </td>

      <td *ngIf="!relaxedEmployeeBranch()">
        <span class="text-muted" *ngIf="!u.employeeId">—</span>
        <span *ngIf="u.employeeId">
          {{ getEmployeeName(u.employeeId) || ('#' + u.employeeId) }}
        </span>
      </td>

      <td *ngIf="!relaxedEmployeeBranch()">
        <div class="branches-view" *ngIf="u.branchIds?.length; else noBranches">
          <div class="branches-view__head">
            <i class="pi pi-building"></i>
            <span class="branches-view__label">الفروع المعينة</span>
            <span class="branches-view__count">{{ u.branchIds!.length }}</span>
          </div>
          <div class="branches-view__list">
            <span class="branch-pill"
                  *ngFor="let bid of u.branchIds!.slice(0, 3)"
                  [title]="getBranchName(bid)">
              <i class="pi pi-map-marker"></i>
              {{ getBranchName(bid) }}
            </span>
            <span class="branch-pill branch-pill--more"
                  *ngIf="u.branchIds!.length > 3"
                  [pTooltip]="branchNamesTooltip(u.branchIds!)"
                  tooltipPosition="top"
                  [escape]="false"
                  tooltipStyleClass="branches-tooltip">
              +{{ u.branchIds!.length - 3 }}
            </span>
          </div>
        </div>
        <ng-template #noBranches>
          <span class="branches-view__empty">
            <i class="pi pi-ban"></i> لا توجد فروع
          </span>
        </ng-template>
      </td>

      <td *ngIf="relaxedEmployeeBranch()">
        <ng-container *ngIf="isPortalEntityUsersPortal(); else insuranceCompanyCell">
          <span class="text-muted" *ngIf="!getPortalEntityId(u)">—</span>
          <span *ngIf="getPortalEntityId(u)">
            {{ getPortalEntityDisplayName(u) || ('#' + getPortalEntityId(u)) }}
          </span>
        </ng-container>
        <ng-template #insuranceCompanyCell>
          <span class="text-muted" *ngIf="!u.labInsuranceCompanyId">—</span>
          <span *ngIf="u.labInsuranceCompanyId">{{ u.labInsuranceCompanyDisplayName || ('#' + u.labInsuranceCompanyId) }}</span>
        </ng-template>
      </td>

      <td>
        <p-tag
          [value]="getStatusLabel(u)"
          [severity]="getStatusSeverity(u)"
        ></p-tag>
      </td>

      <td>
        <div class="chips" *ngIf="u.roles?.length; else noRoles">
          <span class="chip chip--gray" *ngFor="let r of u.roles">{{ r }}</span>
        </div>
        <ng-template #noRoles>—</ng-template>
      </td>

      <td>
        <div class="chips" *ngIf="u.groups?.length; else noGroups">
          <span class="chip chip--gray" *ngFor="let g of u.groups"
            >{{ g }}</span
          >
        </div>
        <ng-template #noGroups>—</ng-template>
      </td>

      <td>
        <div class="date-info">
          <div *ngIf="u.lastLoginAt">
            <div class="label">آخر دخول:</div>
            <div>{{ u.lastLoginAt | date : 'yyyy-MM-dd HH:mm' }}</div>
          </div>
          <div *ngIf="!u.lastLoginAt" class="text-muted">لم يسجل دخول</div>
          <div class="created-date">
            <small class="text-muted">أنشئ: {{ u.createdAt | date : 'yyyy-MM-dd' }}</small>
          </div>
          <div class="created-date" *ngIf="u.isDeleted && u.deletedAt">
            <small class="text-muted">حذف: {{ u.deletedAt | date : 'yyyy-MM-dd' }}</small>
          </div>
        </div>
      </td>

      <td class="text-end">
        <div class="actions">
          <button
            pButton
            icon="pi pi-eye"
            class="icon-btn"
            pTooltip="عرض التفاصيل"
            (click)="openDetails(u.id)"
          ></button>
          <button
            pButton
            icon="pi pi-pencil"
            class="icon-btn"
            pTooltip="تعديل"
            (click)="openEdit(u)"
            *ngIf="!u.isDeleted"
          ></button>
          <button
            pButton
            [icon]="u.isActive ? 'pi pi-ban' : 'pi pi-check'"
            class="icon-btn"
            [pTooltip]="u.isActive ? 'تعطيل' : 'تفعيل'"
            (click)="toggleStatus(u)"
            *ngIf="!u.isDeleted"
          ></button>
          <button
            pButton
            [icon]="u.isLocked ? 'pi pi-unlock' : 'pi pi-lock'"
            class="icon-btn"
            [pTooltip]="u.isLocked ? 'فتح' : 'قفل'"
            (click)="toggleLock(u)"
            *ngIf="!u.isDeleted"
          ></button>
          <button
            pButton
            icon="pi pi-key"
            class="icon-btn warn"
            pTooltip="إعادة تعيين كلمة المرور"
            (click)="openPasswordReset(u)"
            *ngIf="!u.isDeleted"
          ></button>
          <button
            pButton
            icon="pi pi-trash"
            class="icon-btn danger"
            pTooltip="حذف"
            (click)="deleteUser(u)"
            *ngIf="!u.isDeleted"
          ></button>
          <button
            pButton
            icon="pi pi-undo"
            class="icon-btn restore"
            pTooltip="استرجاع"
            (click)="restoreUser(u)"
            *ngIf="u.isDeleted"
          ></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
</div>

<p-dialog [(visible)]="formVisible" [modal]="true" [style]="{ width: '800px' }" [closable]="true" [closeOnEscape]="true" [dismissableMask]="true">
  <ng-template pTemplate="header">
    <span style="display: flex; align-items: center; gap: 0.5rem">
      <i class="pi pi-user-plus" *ngIf="formMode === 'create'"></i>
      <i class="pi pi-user-edit" *ngIf="formMode === 'edit'"></i>
      {{ formMode === 'edit' ? 'تعديل مستخدم' : 'مستخدم جديد' }}
    </span>
  </ng-template>

  <div class="form-grid" *ngIf="!formLoading()">
    <div class="col">
      <div class="field">
        <label>اسم المستخدم <span class="required">*</span></label>
        <input pInputText [(ngModel)]="form.username" [disabled]="formMode === 'edit'" required placeholder="اسم المستخدم" />
        <small class="p-text-secondary" *ngIf="formMode === 'edit'">لا يمكن تعديل اسم المستخدم</small>
      </div>

      <div class="field">
        <label>الاسم الأول</label>
        <input pInputText [(ngModel)]="form.firstName" placeholder="الاسم الأول" />
      </div>

      <div class="field">
        <label>اسم العائلة</label>
        <input pInputText [(ngModel)]="form.lastName" placeholder="اسم العائلة" />
      </div>

      <div class="field">
        <label>البريد الإلكتروني</label>
        <input pInputText type="email" [(ngModel)]="form.email" placeholder="user@example.com" />
      </div>

      <div class="field">
        <label>رقم الهاتف</label>
        <input pInputText type="tel" [(ngModel)]="form.phone" placeholder="+1234567890" />
      </div>

      <div class="field" *ngIf="formMode === 'create'">
        <label>كلمة المرور <span class="required">*</span></label>
        <input pInputText type="password" [(ngModel)]="form.password" required placeholder="كلمة المرور" />
        <small class="p-text-secondary">سيتم إجبار المستخدم على تغيير كلمة المرور في المرة القادمة</small>
      </div>

      <div class="field">
        <label>الحالة</label>
        <div style="display: flex; align-items: center; gap: 0.5rem">
          <p-toggleButton [(ngModel)]="form.isActive" onLabel="نشط" offLabel="معطل"></p-toggleButton>
          <span style="font-size: 0.875rem; color: #6b7280">{{ form.isActive ? 'المستخدم نشط' : 'المستخدم معطل' }}</span>
        </div>
      </div>
    </div>

    <div class="col">
      <div class="field" *ngIf="!relaxedEmployeeBranch()">
        <label>الموظف <span class="required">*</span></label>
        <p-dropdown
          [options]="employeeOptions"
          [(ngModel)]="formSelectedEmployeeId"
          optionLabel="label"
          optionValue="value"
          [showClear]="false"
          placeholder="اختر الموظف"
          styleClass="w-full"
          [filter]="true"
          filterBy="label"
          appendTo="body"
          [class.ng-invalid]="formMode === 'create' && !formSelectedEmployeeId && formSubmitted"
          [class.ng-dirty]="formMode === 'create' && formSubmitted"
        ></p-dropdown>
        <small class="p-text-secondary">ربط المستخدم بموظف من نظام HR</small>
        <small class="p-error" *ngIf="formMode === 'create' && !formSelectedEmployeeId && formSubmitted">
          الموظف مطلوب
        </small>
      </div>

      <div class="field" *ngIf="!relaxedEmployeeBranch()">
        <label>الفروع <span class="required">*</span></label>
        <p-multiSelect
          [options]="branchOptions"
          [(ngModel)]="formSelectedBranchIds"
          optionLabel="label"
          optionValue="value"
          display="chip"
          [showClear]="false"
          [showToggleAll]="false"
          placeholder="اختر الفروع"
          styleClass="w-full"
          [filter]="true"
          filterBy="label"
          appendTo="body"
          [class.ng-invalid]="formMode === 'create' && (!formSelectedBranchIds || formSelectedBranchIds.length === 0) && formSubmitted"
          [class.ng-dirty]="formMode === 'create' && formSubmitted"
        ></p-multiSelect>
        <small class="p-text-secondary">يجب اختيار فرع واحد على الأقل للمستخدم</small>
        <small class="p-error" *ngIf="formMode === 'create' && (!formSelectedBranchIds || formSelectedBranchIds.length === 0) && formSubmitted">
          يجب اختيار فرع واحد على الأقل
        </small>
      </div>

      <div class="field" *ngIf="relaxedEmployeeBranch()">
        <p class="p-text-secondary" style="margin: 0 0 0.5rem 0; font-size: 0.9rem">
          {{ 'INSURANCE_USERS.HINT_NO_HR' | translate }}
        </p>
      </div>

      <div class="field" *ngIf="portalSystemKey() === 'insurance'">
        <label>{{ 'INSURANCE_USERS.COMPANY_LABEL' | translate }} <span class="required">*</span></label>
        <p-dropdown
          [options]="insuranceCompanyOptions"
          [(ngModel)]="formSelectedInsuranceCompanyId"
          optionLabel="label"
          optionValue="value"
          [showClear]="false"
          [placeholder]="'INSURANCE_USERS.COMPANY_PLACEHOLDER' | translate"
          styleClass="w-full"
          [filter]="true"
          filterBy="label"
          appendTo="body"
          [class.ng-invalid]="formMode === 'create' && !formSelectedInsuranceCompanyId && formSubmitted"
          [class.ng-dirty]="formMode === 'create' && formSubmitted"
        ></p-dropdown>
        <small class="p-text-secondary">{{ 'INSURANCE_USERS.COMPANY_HINT' | translate }}</small>
        <small class="p-error" *ngIf="formMode === 'create' && !formSelectedInsuranceCompanyId && formSubmitted">
          {{ 'INSURANCE_USERS.COMPANY_REQUIRED' | translate }}
        </small>
      </div>

      <div class="field" *ngIf="isPortalEntityUsersPortal()">
        <label>{{ portalEntityLabelKey | translate }} <span class="required">*</span></label>
        <p-dropdown
          [options]="portalEntityOptions"
          [(ngModel)]="formSelectedPortalEntityId"
          optionLabel="label"
          optionValue="value"
          [showClear]="false"
          [placeholder]="portalEntityPlaceholderKey | translate"
          styleClass="w-full"
          [filter]="true"
          filterBy="label"
          appendTo="body"
          [class.ng-invalid]="formMode === 'create' && !formSelectedPortalEntityId && formSubmitted"
          [class.ng-dirty]="formMode === 'create' && formSubmitted"
        ></p-dropdown>
        <small class="p-text-secondary">{{ portalEntityHintKey | translate }}</small>
        <small class="p-error" *ngIf="formMode === 'create' && !formSelectedPortalEntityId && formSubmitted">
          {{ portalEntityRequiredKey | translate }}
        </small>
      </div>

      <div class="field">
        <label>الأدوار</label>
        <p-multiSelect
          [options]="roleOptions"
          [(ngModel)]="formSelectedRoles"
          optionLabel="label"
          optionValue="value"
          display="chip"
          [showClear]="true"
          [showToggleAll]="false"
          placeholder="اختر الأدوار"
          styleClass="w-full"
        ></p-multiSelect>
        <small class="p-text-secondary">يمكن اختيار عدة أدوار للمستخدم</small>
      </div>

      <div class="field">
        <label>المجموعات</label>
        <p-multiSelect
          [options]="groupOptions"
          [(ngModel)]="formSelectedGroups"
          optionLabel="label"
          optionValue="value"
          display="chip"
          [showClear]="true"
          [showToggleAll]="false"
          placeholder="اختر المجموعات"
          styleClass="w-full"
          appendTo="body"
        ></p-multiSelect>
        <small class="p-text-secondary">يمكن اختيار عدة مجموعات للمستخدم</small>
      </div>

      <div class="field">
        <label>الأنظمة المسموح بالوصول إليها</label>
        <p-multiSelect
          [options]="systemOptions"
          [(ngModel)]="formSelectedSystemKeys"
          optionLabel="label"
          optionValue="value"
          display="chip"
          [showClear]="true"
          [showToggleAll]="false"
          placeholder="اختر الأنظمة (HR، المختبر، البوابة…)"
          styleClass="w-full"
          appendTo="body"
        ></p-multiSelect>
        <small class="p-text-secondary" *ngIf="!relaxedEmployeeBranch()">
          يحدد التطبيقات التي يظهر للمستخدم الدخول إليها من «التطبيقات المتاحة» ونطاقات OAuth (hr / lab).
        </small>
        <small class="p-text-secondary" *ngIf="relaxedEmployeeBranch() && !isPortalEntityUsersPortal()">
          {{ 'INSURANCE_USERS.HINT_SYSTEMS' | translate }}
        </small>
        <small class="p-text-secondary" *ngIf="isPortalEntityUsersPortal()">
          {{ portalEntityHintKey | translate }}
        </small>
      </div>
    </div>
  </div>

  <div *ngIf="formLoading()" style="text-align: center; padding: 2rem">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    <p style="margin-top: 1rem; color: #6b7280">جاري الحفظ...</p>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      label="إلغاء"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="formVisible = false; formSubmitted = false"
      [disabled]="formLoading()"
    ></button>
    <button
      pButton
      [label]="formMode === 'edit' ? 'تحديث' : 'إنشاء'"
      [icon]="formMode === 'edit' ? 'pi pi-check' : 'pi pi-plus'"
      (click)="saveUser()"
      [disabled]="formLoading()"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="passwordResetVisible"
  [modal]="true"
  [style]="{ width: '420px' }"
  [closeOnEscape]="true"
  [dismissableMask]="true"
>
  <ng-template pTemplate="header">
    إعادة تعيين كلمة المرور
  </ng-template>

  <div class="p-fluid form">
    <div class="field">
      <label>كلمة المرور الجديدة <span class="required">*</span></label>
      <div class="p-inputgroup">
        <input pInputText type="text" [(ngModel)]="passwordResetPassword" required />
        <button
          pButton
          type="button"
          icon="pi pi-refresh"
          class="p-button-secondary"
          pTooltip="توليد كلمة مرور عشوائية"
          (click)="generateRandomPassword()"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-copy"
          class="p-button-secondary"
          pTooltip="نسخ"
          [disabled]="!passwordResetPassword"
          (click)="copyPasswordResetValue()"
        ></button>
      </div>
      <small class="p-text-secondary">سيتم إجبار المستخدم على تغيير كلمة المرور في المرة القادمة</small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton label="إلغاء" class="p-button-secondary" (click)="passwordResetVisible = false" [disabled]="passwordResetLoading()"></button>
    <button pButton label="تعيين" (click)="resetPassword()" [disabled]="!passwordResetPassword || passwordResetLoading()"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog></p-confirmDialog>

<!-- User Details Sidebar -->
<p-sidebar
  [visible]="detailsVisible()"
  (visibleChange)="detailsVisible.set($event)"
  [position]="'right'"
  [style]="{ width: '600px' }"
  [modal]="true"
  [dismissible]="false"
  [showCloseIcon]="true"
  [closeOnEscape]="true"
>
  <ng-template pTemplate="header">
    <div style="display: flex; align-items: center; gap: 0.5rem">
      <i class="pi pi-user"></i>
      <span>تفاصيل المستخدم</span>
    </div>
  </ng-template>

  <div *ngIf="detailsLoading()" style="text-align: center; padding: 2rem">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    <p style="margin-top: 1rem; color: #6b7280">جاري التحميل...</p>
  </div>

  <div *ngIf="!detailsLoading() && selectedUser()" class="user-details">
    <p-tabView 
      [activeIndex]="detailsTabIndex" 
      (activeIndexChange)="detailsTabIndex = $event"
      (click)="$event.stopPropagation()"
    >
      <!-- Overview Tab -->
      <p-tabPanel header="نظرة عامة">
        <div class="detail-section">
          <h3>المعلومات الأساسية</h3>
          <div class="detail-grid">
            <div class="detail-item">
              <label>اسم المستخدم:</label>
              <span>{{ selectedUser()?.username }}</span>
            </div>
            <div class="detail-item">
              <label>الاسم الكامل:</label>
              <span>{{ selectedUser()?.fullName || '—' }}</span>
            </div>
            <div class="detail-item">
              <label>الاسم الأول:</label>
              <span>{{ selectedUser()?.firstName || '—' }}</span>
            </div>
            <div class="detail-item">
              <label>اسم العائلة:</label>
              <span>{{ selectedUser()?.lastName || '—' }}</span>
            </div>
            <div class="detail-item">
              <label>البريد الإلكتروني:</label>
              <span>{{ selectedUser()?.email || '—' }}</span>
            </div>
            <div class="detail-item">
              <label>رقم الهاتف:</label>
              <span>{{ selectedUser()?.phone || '—' }}</span>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <h3>الحالة والأمان</h3>
          <div class="detail-grid">
            <div class="detail-item">
              <label>الحالة:</label>
              <p-tag
                [value]="getStatusLabel(selectedUser()!)"
                [severity]="getStatusSeverity(selectedUser()!)"
              ></p-tag>
            </div>
            <div class="detail-item">
              <label>يجب تغيير كلمة المرور:</label>
              <span>{{ selectedUser()?.mustChangePassword ? 'نعم' : 'لا' }}</span>
            </div>
            <div class="detail-item">
              <label>مقفل:</label>
              <span>{{ selectedUser()?.isLocked ? 'نعم' : 'لا' }}</span>
            </div>
            <div class="detail-item">
              <label>عدد محاولات الدخول الفاشلة:</label>
              <span>{{ selectedUser()?.accessFailedCount || 0 }}</span>
            </div>
            <div class="detail-item">
              <label>الجلسات النشطة:</label>
              <span>{{ selectedUser()?.sessionsCount || 0 }}</span>
            </div>
          </div>
        </div>

        <div class="detail-section" *ngIf="!relaxedEmployeeBranch()">
          <h3>الموظف والفروع</h3>
          <div class="detail-grid">
            <div class="detail-item">
              <label>الموظف:</label>
              <span *ngIf="selectedUser()?.employeeId">
                {{ getEmployeeName(selectedUser()!.employeeId!) || ('#' + selectedUser()!.employeeId) }}
              </span>
              <span *ngIf="!selectedUser()?.employeeId" class="text-muted">—</span>
            </div>
            <div class="detail-item">
              <label>الفروع المعينة:</label>
              <div class="branches-view branches-view--detail"
                   *ngIf="selectedUser()?.branchIds?.length; else noBranchesDetail">
                <div class="branches-view__head">
                  <i class="pi pi-building"></i>
                  <span class="branches-view__label">عدد الفروع</span>
                  <span class="branches-view__count">{{ selectedUser()!.branchIds!.length }}</span>
                </div>
                <div class="branches-view__list">
                  <span class="branch-pill" *ngFor="let bid of selectedUser()!.branchIds">
                    <i class="pi pi-map-marker"></i>
                    {{ getBranchName(bid) }}
                  </span>
                </div>
              </div>
              <ng-template #noBranchesDetail>
                <span class="branches-view__empty">
                  <i class="pi pi-ban"></i> لا توجد فروع معينة
                </span>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="detail-section" *ngIf="relaxedEmployeeBranch() && !isPortalEntityUsersPortal()">
          <h3>{{ 'INSURANCE_USERS.COMPANY_SECTION' | translate }}</h3>
          <div class="detail-grid">
            <div class="detail-item">
              <label>{{ 'INSURANCE_USERS.COMPANY_LABEL' | translate }}:</label>
              <span *ngIf="selectedUser()?.labInsuranceCompanyId">
                {{ selectedUser()?.labInsuranceCompanyNameAr || selectedUser()?.labInsuranceCompanyNameEn || ('#' + selectedUser()?.labInsuranceCompanyId) }}
              </span>
              <span *ngIf="!selectedUser()?.labInsuranceCompanyId" class="text-muted">—</span>
            </div>
          </div>
        </div>

        <div class="detail-section" *ngIf="isPortalEntityUsersPortal()">
          <h3>{{ portalEntitySectionKey | translate }}</h3>
          <div class="detail-grid">
            <div class="detail-item">
              <label>{{ portalEntityLabelKey | translate }}:</label>
              <span *ngIf="getSelectedPortalEntityId()">
                {{ getSelectedPortalEntityName() || ('#' + getSelectedPortalEntityId()) }}
              </span>
              <span *ngIf="!getSelectedPortalEntityId()" class="text-muted">—</span>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <h3>الأدوار والمجموعات</h3>
          <div class="detail-grid">
            <div class="detail-item">
              <label>الأدوار:</label>
              <div class="chips" *ngIf="selectedUser()?.roles?.length; else noRolesDetail">
                <span class="chip chip--gray" *ngFor="let r of selectedUser()!.roles">{{ r }}</span>
              </div>
              <ng-template #noRolesDetail>
                <span class="text-muted">—</span>
              </ng-template>
            </div>
            <div class="detail-item">
              <label>المجموعات:</label>
              <div class="chips" *ngIf="selectedUser()?.groups?.length; else noGroupsDetail">
                <span class="chip chip--gray" *ngFor="let g of selectedUser()!.groups">{{ g }}</span>
              </div>
              <ng-template #noGroupsDetail>
                <span class="text-muted">—</span>
              </ng-template>
            </div>
            <div class="detail-item" style="grid-column: 1 / -1">
              <label>الأنظمة المسموح بالوصول إليها:</label>
              <div class="chips" *ngIf="selectedUser()?.allowedSystemKeys?.length; else noSystemsDetail">
                <span class="chip chip--gray" *ngFor="let k of selectedUser()!.allowedSystemKeys">{{ k }}</span>
              </div>
              <ng-template #noSystemsDetail>
                <span class="text-muted">—</span>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <h3>التواريخ</h3>
          <div class="detail-grid">
            <div class="detail-item">
              <label>تاريخ الإنشاء:</label>
              <span>{{ formatDate(selectedUser()?.createdAt) }}</span>
            </div>
            <div class="detail-item">
              <label>آخر تحديث:</label>
              <span>{{ formatDate(selectedUser()?.updatedAt) }}</span>
            </div>
            <div class="detail-item">
              <label>آخر دخول:</label>
              <span>{{ formatDate(selectedUser()?.lastLoginAt) }}</span>
            </div>
            <div class="detail-item">
              <label>آخر تغيير لكلمة المرور:</label>
              <span>{{ formatDate(selectedUser()?.passwordChangedAt) }}</span>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <!-- Activity Tab -->
      <p-tabPanel header="النشاط">
        <div *ngIf="auditLoading()" style="text-align: center; padding: 2rem">
          <i class="pi pi-spin pi-spinner"></i>
          <p>جاري التحميل...</p>
        </div>
        <div *ngIf="!auditLoading()">
          <p *ngIf="auditLogs().length === 0" class="text-muted" style="text-align: center; padding: 2rem">
            لا توجد سجلات نشاط
          </p>
          <div *ngIf="auditLogs().length > 0" class="audit-logs">
            <div *ngFor="let log of auditLogs()" class="audit-log-item">
              <div class="audit-log-header">
                <span class="audit-action">{{ log.actionType }}</span>
                <span class="audit-date">{{ formatDate(log.createdAt) }}</span>
              </div>
              <div class="audit-description" *ngIf="log.description">{{ log.description }}</div>
              <div class="audit-actor" *ngIf="log.actorUsername">
                <small>بواسطة: {{ log.actorUsername }}</small>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <!-- Sessions Tab -->
      <p-tabPanel header="الجلسات">
        <div *ngIf="sessionsLoading()" style="text-align: center; padding: 2rem">
          <i class="pi pi-spin pi-spinner"></i>
          <p>جاري التحميل...</p>
        </div>
        <div *ngIf="!sessionsLoading()">
          <p *ngIf="userSessions().length === 0" class="text-muted" style="text-align: center; padding: 2rem">
            لا توجد جلسات نشطة
          </p>
          <div *ngIf="userSessions().length > 0" class="sessions-list">
            <div *ngFor="let session of userSessions()" class="session-item">
              <div class="session-info">
                <div><strong>الجهاز:</strong> {{ session.device }}</div>
                <div *ngIf="session.ipAddress"><strong>عنوان IP:</strong> {{ session.ipAddress }}</div>
                <div><strong>تاريخ الإنشاء:</strong> {{ formatDate(session.createdAt) }}</div>
                <div *ngIf="session.expiresAt"><strong>ينتهي في:</strong> {{ formatDate(session.expiresAt) }}</div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</p-sidebar>
